var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _subscriptions;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import workflow, { INITIAL_STATE, createState } from '@banking/ui/workflows/investments/index';
import { tracked } from '@glimmer/tracking';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createSelect, createEmit } from '@banking/ui/lib/workflow-ember/decorators';
import { Subscription } from 'rxjs';
import connect from '@banking/ui/lib/workflow-ember/connect';
import routerTransitions from '@banking/ui/workflows/investments/router-transitions';
import { v4 as uuid } from 'uuid';
import { isInvestmentsRoute } from '@banking/ui/utils/investments';
const SERVICE_REGISTRY_KEY = 'investments-workflow';
let InvestmentsWorkflow = (_class = (_subscriptions = /*#__PURE__*/new WeakMap(), class InvestmentsWorkflow extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "investments", _descriptor3, this);
    _initializerDefineProperty(this, "features", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor6, this);
    _initializerDefineProperty(this, "router", _descriptor7, this);
    _initializerDefineProperty(this, "multipassExternalApi", _descriptor8, this);
    _initializerDefineProperty(this, "dataApi", _descriptor9, this);
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: void 0
    });
    _initializerDefineProperty(this, "state", _descriptor10, this);
    _defineProperty(this, "states", void 0);
    _defineProperty(this, "emit", void 0);
    _defineProperty(this, "updates", void 0);
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    const seededState = {
      ...createState(),
      canSeeBitcoinFiatConversion: this.features.isEnabled('squareinvest/bitcoin_fiat_conversion'),
      canSeeCashTagLinking: this.features.isEnabled('squareinvest/cashtag_linking')
    };
    const {
      emit,
      states,
      updates
    } = workflow(seededState, {
      investmentsApi: this.investments.client,
      sentry: this.sentry,
      marketToasts: this.marketToasts,
      intl: this.intl,
      router: this.router,
      multipass: this.multipassExternalApi.client,
      dataApi: this.dataApi,
      capitalEngineContext: this.capitalEngineContext,
      getUUIDString: () => uuid()
    });
    this.emit = emit;
    this.states = states;
    this.updates = updates;
    states.subscribe(state => {
      this.state = state;
    });
    updates.subscribe(updateLogger('Investments'));

    // router transition side-effects
    _classPrivateFieldGet2(this, _subscriptions).add(updates.pipe(routerTransitions).subscribe(routeArgs => {
      // FIXME(steckel): Use TypeScript parameter inference once overloaded functions
      // are supported (https://github.com/microsoft/TypeScript/issues/32164)
      if (isInvestmentsRoute(this.router.currentRouteName)) {
        this.router.transitionTo(...routeArgs);
      }
    }));
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "investments", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "multipassExternalApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL_STATE;
  }
}), _class);
export { InvestmentsWorkflow as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);